export default __webpack_public_path__ + "static/media/colorDiscord.1c38635d.svg";